// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.property-selection-modal.wide-modal {
  width: 100%;
  min-width: 800px;
  max-width: 1000px;
  max-height: 80vh;
  overflow: hidden;
}
.property-selection-modal .modal-content {
  padding: 16px 0;
  max-height: 60vh;
  overflow-y: auto;
}
.property-selection-modal .modal-content .search-section {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}
.property-selection-modal .modal-content .search-section .edition-field,
.property-selection-modal .modal-content .search-section .search-field {
  flex: 1;
}
@media (max-width: 768px) {
  .property-selection-modal .modal-content .search-section {
    flex-direction: column;
    gap: 8px;
  }
}
.property-selection-modal .modal-content .loading-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px;
}
.property-selection-modal .modal-content .loading-section mat-spinner {
  margin-bottom: 16px;
}
.property-selection-modal .modal-content .loading-section p {
  color: #666;
  font-size: 0.9rem;
  text-align: center;
}
.property-selection-modal .modal-content .error-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px;
  text-align: center;
}
.property-selection-modal .modal-content .error-section mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
}
.property-selection-modal .modal-content .error-section p {
  color: #d32f2f;
  margin-bottom: 16px;
}
.property-selection-modal .modal-content .options-section .options-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}
.property-selection-modal .modal-content .options-section .options-header h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 500;
}
.property-selection-modal .modal-content .options-section .options-header .options-count {
  color: #666;
  font-size: 0.9rem;
}
.property-selection-modal .modal-content .options-section .no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px;
}
.property-selection-modal .modal-content .options-section .no-results mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #ccc;
  margin-bottom: 16px;
}
.property-selection-modal .modal-content .options-section .no-results p {
  color: #666;
  margin-bottom: 16px;
  text-align: center;
}
.property-selection-modal .modal-content .options-section .property-options.three-columns {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px 16px;
  padding: 8px 0;
}
.property-selection-modal .modal-content .options-section .property-options .property-option {
  padding: 8px 0;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.property-selection-modal .modal-content .options-section .property-options .property-option ::ng-deep .mat-radio-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.property-selection-modal .modal-content .options-section .property-options .property-option:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.property-selection-modal .modal-content .options-section .property-options .property-option.mat-radio-checked {
  background-color: rgba(0, 102, 178, 0.1);
  color: #0066b2;
}
.property-selection-modal .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 0 8px 0;
  border-top: 1px solid #e0e0e0;
}
.property-selection-modal .modal-actions button {
  min-width: 100px;
}

@media (max-width: 768px) {
  .property-selection-modal.wide-modal {
    min-width: 350px;
    max-width: 95vw;
  }
  .property-selection-modal .modal-actions {
    flex-direction: column;
  }
  .property-selection-modal .modal-actions button {
    width: 100%;
  }
  .property-selection-modal .modal-content .options-section .property-options.three-columns {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 480px) {
  .property-selection-modal .modal-content .options-section .property-options.three-columns {
    grid-template-columns: 1fr;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
